import { store } from "@/redux/store";
import { isSystemUser } from "@/utils/orgTypeUtils";
import { DeviceViewTabs } from "@/utils/DeviceTabUtils";
import DeviceAdminRoute from "./_deviceAdminRoute";

/** A url query value. `boolean`/`null` are here because callers pass them;
 *  `URLSearchParams` stringifies whatever survives the falsy check. */
type RouteParamValue = string | number | boolean | null | undefined;

interface DeviceHomePageData {
  [key: string]: RouteParamValue;
}

interface DeviceHomeUpdateData {
  id?: RouteParamValue;
  tabActive?: RouteParamValue;
  type?: RouteParamValue;
  org?: RouteParamValue;
  [key: string]: RouteParamValue;
}

interface DeviceHomeRoute {
  page: string;
  updatePage: string;
  createPage: string;
  getPage: (data?: DeviceHomePageData) => string;
  getUpdatePage: (data: DeviceHomeUpdateData) => string;
}

const _deviceHomeRoute: DeviceHomeRoute = {
  page: "/tracked_assets",
  updatePage: "/tracked_assets_update",
  createPage: "",
  getPage: (data) => {
    return `/tracked_assets`;
  },
  getUpdatePage: (data) => {
    // SYSTEM users have no "home" menu — /tracked_assets_update would land them
    // on an empty sidebar. Route them to the admin device page instead (STIC-15212).
    // It's the same DeviceDetailPage with the same View tabs, so keep the caller's
    // tab. Without one the admin page would fall back to SETTING, so default to
    // the View landing tab (STIC-16133).
    if (isSystemUser(store.getState().user)) {
      return DeviceAdminRoute.getUpdatePage({
        ...data,
        tabActive: data.tabActive || DeviceViewTabs.asset_details_tab,
      });
    }
    const queryString = new URLSearchParams(
      data as Record<string, string>
    ).toString();
    return `/tracked_assets_update?${queryString}`;
  },
};

export default _deviceHomeRoute;
